import {
  WEBSITE_TRAFFIC_MONTHLY,
  WEBSITE_TRAFFIC_TOTALS,
} from '@mm/api-routes';
import {
  SEMRushWebsiteTrafficByMonthModel,
  SEMRushWebsiteTrafficModel,
} from '../model/SEMRushWebsiteTrafficModel';
import Controller from './Controller';

export default class SEMRushWebsiteTrafficController extends Controller {
  static async getTotalsByDomain(
    domain: string,
    ipAdress?: number,
  ): Promise<SEMRushWebsiteTrafficModel> {
    return super.get(`${WEBSITE_TRAFFIC_TOTALS}?d=${domain}&ip=${ipAdress}`);
  }

  static async getMonthlyByDomain(
    domain: string,
    ipAdress?: number,
  ): Promise<SEMRushWebsiteTrafficByMonthModel> {
    return super.get(`${WEBSITE_TRAFFIC_MONTHLY}?d=${domain}&ip=${ipAdress}`);
  }
}
